import React, { useEffect, useState } from "react";
import { Spinner, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import ReuseableTable from "components/Tables/ReuseableTable";
import { fetchContestDetails } from "store/actions/sportContestAction";

const column = ["Athlete Id", "First Name", "Last Name", "Email"];

const keyMaps = {
  "Athlete Id": "athleteID",
  "First Name": "firstName",
  "Last Name": "lastName",
  Email: "email",
};

const ContestAthletes = ({ contestId }) => {
  const dispatch = useDispatch();
  const { contestDetails } = useSelector((state) => state.contest);

  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLoadMore = () => {
    setIsLoading(true);
    dispatch(
      fetchContestDetails({
        collectionName: "contest_athletes",
        contestId,
        lastVisible: contestDetails?.lastVisible,
      })
    ).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    setIsFetching(true);
    dispatch(
      fetchContestDetails({ collectionName: "contest_athletes", contestId })
    ).finally(() => setIsFetching(false));
  }, []);

  return (
    <div className="p-0">
      {isFetching ? (
        <div className="text-center py-4 text-primary">
          <Spinner animation="border" size="md" />
        </div>
      ) : (
        <>
          <ReuseableTable
            columns={column}
            data={contestDetails?.data}
            keyMap={keyMaps}
          />
          {contestDetails?.hasMore && (
            <div className="text-center py-2">
              <Button
                color="primary"
                onClick={handleLoadMore}
                disabled={isFetching || isLoading}
              >
                {isLoading ? <Spinner size="sm" /> : "Load More"}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ContestAthletes;
